import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ButtonGroup, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import { useDeleteSectionByIdMutation } from '../../../store/api/expert/Section/section'
import { UseToggleModalHOC } from '../../../hooks/toggleModal'
import RemoveItemModal from '../../../utils/RemoveItemModal/removeItemModal'
import { IGetAllSectionItem } from '../../../store/api/expert/Section/model'

const SectionTable: FC<{ section: IGetAllSectionItem; refetch: () => void }> = ({
  section,
  refetch
}): JSX.Element => {
  const { t: tGeneral } = useTranslation('general')
  const navigate = useNavigate()
  const { isModalVisible, toggleModal } = UseToggleModalHOC()
  const [deleteExpert] = useDeleteSectionByIdMutation()

  return (
    <tr className='text-center'>
      <td>{section.title}</td>
      <td>{section.description}</td>
      <td>{section.link}</td>
      <td className='align-middle'>
        <span className='text-center align-middle'>
          <ButtonGroup size='sm' className='flex-nowrap'>
            <OverlayTrigger placement='top' overlay={<Tooltip>{tGeneral('edit')}</Tooltip>}>
              <Button onClick={() => navigate(`/experts/section/edit/${section.id}`)}>
                {tGeneral('edit')}
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement='top' overlay={<Tooltip>{tGeneral('view')}</Tooltip>}>
              <Button onClick={() => toggleModal()}>{tGeneral('delete')}</Button>
            </OverlayTrigger>
          </ButtonGroup>
        </span>
      </td>
      {isModalVisible && (
        <RemoveItemModal
          id={Number(section.id)}
          deleteItem={deleteExpert}
          reload={refetch}
          onClose={() => toggleModal()}
        />
      )}
    </tr>
  )
}

export default SectionTable
